import React from 'react';
import { Image, Linking, StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import Touchable from './Touchable';

// import { AuthContext } from '../components/context';
export const Footer: React.FC = (props) => {
  return (
    <Touchable
      style={{ alignItems: 'center', justifyContent: 'center' }}
      onPress={() => Linking.openURL('http://edilsystem.com.br/site/contato/')}
    >
      <Text style={{ fontSize: 10, fontWeight: '900', marginBottom: 5 }}>POWERED BY</Text>
      <Image
        source={require('../../../assets/logo_edilsystem.png')}
        style={{
          width: '100%',
          height: 40,
          resizeMode: 'contain',
          marginBottom: 10
        }}
      />
    </Touchable>
  );
};

const styles = StyleSheet.create({});

export default Footer;
